"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
function edit(_a) {
    var width = _a.width, height = _a.height, className = _a.className;
    return (react_1.default.createElement("svg", { className: "icon ".concat(className), height: "".concat(height), viewBox: "0 0 64 64", width: "".concat(width) },
        react_1.default.createElement("path", { clipRule: "evenodd", d: "M31.1019 15H12C8.13401 15 5 18.134 5 22V52C5 55.866 8.13401 59 12 59H42C45.866 59 49 55.866 49 52V30.2012L46 33.4166V52C46 54.2091 44.2091 56 42 56H12C9.79086 56 8 54.2091 8 52V22C8 19.7909 9.79086 18 12 18H28.3029L31.1019 15Z", fill: "black", fillRule: "evenodd" }),
        react_1.default.createElement("path", { d: "M41.9745 12L51.2039 21.1552L31.2294 41.2917L22 32.1364L41.9745 12Z", fill: "black" }),
        react_1.default.createElement("path", { d: "M15.2932 47.7103L20.809 33.0597L29.9772 42.2839L15.2932 47.7103Z", fill: "black" }),
        react_1.default.createElement("path", { d: "M45.2529 8.54978C47.1977 6.58929 50.3635 6.57651 52.3239 8.52123L54.4538 10.634C56.4143 12.5787 56.4271 15.7445 54.4824 17.705L52.2294 19.9762L43 10.821L45.2529 8.54978Z", fill: "black" })));
}
edit.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    className: prop_types_1.default.string,
};
edit.defaultProps = {
    width: 64,
    height: 64,
};
exports.default = edit;
